/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AccountStatus {
    INACTIVE = 'Inactive',
    ACTIVE = 'Active',
    BANNED = 'Banned',
}